'use client'

import { useSiteConfig } from '@/feature/config/hooks/useSiteConfig.client'

export function useStoreLocatorUrl(): string | undefined {
  const { config } = useSiteConfig()

  return config?.pointOfSale?.storeLocatorUrl?.trim() || undefined
}
